import accountsFinancialPosition from './accountsFinancialPosition'

export * from './accountsFinancialPosition'
export default accountsFinancialPosition
